export default __webpack_public_path__ + "static/media/tc-energy-en.f9806a27.svg";